import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=6b637f4b&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b637f4b')) {
      api.createRecord('6b637f4b', component.options)
    } else {
      api.reload('6b637f4b', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=6b637f4b&", function () {
      api.rerender('6b637f4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wFs8uwBo9sHJ/JS/comp/openstreetmap.vue"
export default component.exports